// extracted by mini-css-extract-plugin
module.exports = {"zoomEvent":"ZoomEvent_zoomEvent__36tgS","image":"ZoomEvent_image__2RtAd","info":"ZoomEvent_info__3TTxe","register":"ZoomEvent_register__3lfMf"};